// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
.content-box {
  height: calc(100% - 120px);
}
/*# sourceMappingURL=content-layout.component.css.map */`, "",{"version":3,"sources":["webpack://./src/app/layout/content-layout/content-layout.component.less","webpack://./content-layout.component.less"],"names":[],"mappings":"AAAA,cAAc;ACEd;EACE,0BAAA;ADAF;AACA,uDAAuD","sourcesContent":["/* Variables */\n.content-box {\n  height: calc(100% - 120px);\n}\n/*# sourceMappingURL=content-layout.component.css.map */","@import '../../../assets/css/constant.less';\n\n.content-box{\n  height: calc(100% - @header-height);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
